import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Sets <title> + <meta name="description"> dynamically based on the route.
 * Cleans up to the default site values on unmount. */
const SITE_NAME = "CSE Investor";
const DEFAULT_TITLE = "CSE Investor — Colombo Stock Exchange Research";
const DEFAULT_DESC = "Professional stock research for the Colombo Stock Exchange. AI-powered analysis, portfolio tracking, and dividend monitoring for CSE investors.";

const SeoHead = ({ title, description, keywords, ogTitle, ogDescription, ogUrl }) => {
  const location = useLocation();

  useEffect(() => {
    const finalTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
    const finalDesc = description || DEFAULT_DESC;

    document.title = finalTitle;

    const setMeta = (name, content, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", finalDesc);
    if (keywords) setMeta("keywords", keywords);
    setMeta("og:title", ogTitle || finalTitle, true);
    setMeta("og:description", ogDescription || finalDesc, true);
    setMeta("og:type", "website", true);
    if (ogUrl || typeof window !== "undefined") {
      setMeta("og:url", ogUrl || window.location.href, true);
    }
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", ogTitle || finalTitle);
    setMeta("twitter:description", ogDescription || finalDesc);

    return () => {
      // Reset to defaults on unmount
      document.title = DEFAULT_TITLE;
      setMeta("description", DEFAULT_DESC);
    };
  }, [title, description, keywords, ogTitle, ogDescription, ogUrl, location.pathname]);

  return null;
};

export default SeoHead;
